import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { useTranslation } from 'react-i18next'
import { CreatePromotionForm } from '@/features/Promotion/CreatePromotionForm'

type CreatePromotionModalProps = {
  dialogProps: AlertDialogProps
  onCloseModal: () => void
}

export const CreatePromotionModal: FC<CreatePromotionModalProps> = props => {
  const { dialogProps, onCloseModal } = props
  const { t } = useTranslation(['promotion'])
  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'overflow-y-auto max-h-[95vh]'}>
        <DialogHeader>
          <DialogTitle>{t('promotion:create_promotion_modal_title')}</DialogTitle>
          <CreatePromotionForm onCloseModal={onCloseModal} />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
